/*
 * File: AppointmentPatientSelectionDialog.js
 * Project: mp-mobile-app
 *
 * Created by Vamsi Sureddy
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles and styles the patient selection dialog form with Patient and Search For a Different Patient button
 */
import React from "react";
import { List, Typography, ListItem } from "@material-ui/core";
import UIDialog from "components/ui/UIDialog";
import PatientSearchDialog from "./PatientSearchDialog";
import CloseIcon from "@material-ui/icons/Close";
import PatientIdStore from "services/patients/store/PatientIdStore";
import UIStore from "../store/UIStore";
import ApptStore from "services/appointments/store/DataStore";
import { observer } from "mobx-react";
import PatientSelectionCard from "./PatientSelectionCard";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { StoreContext } from "utils/useStore";

const styles = theme => ({
  searchButton: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    width: "100%"
  },
  buttonContainer: {
    marginTop: theme.spacing(2)
  }
});

class AppointmentPatientSelectionDialog extends React.Component {
  state = { showSearchDialog: !this.isPatientSelected() };
  static contextType = StoreContext;

  get uiStore() {
    return this.context.getStore(UIStore);
  }

  toggleSearchDialog = () => {
    this.setState({
      showSearchDialog: !this.state.showSearchDialog
    });
  };

  close = () => {
    this.uiStore.togglePatientSelection();
    this.setState({ showSearchDialog: !this.isPatientSelected() });
  };

  isPatientSelected() {
    let patientId = PatientIdStore.getId();
    return patientId > 1 && patientId;
  }

  patientSelectionResult = (patient, providerId) => {
    let { newAppt } = this.context.getStore(ApptStore);
    newAppt.setPatient(patient);
    newAppt.setProvider(providerId);
    this.uiStore.toggleFormDialog();
  };

  render() {
    let { showSearchDialog } = this.state;
    let { showPatientSelection, togglePatientSelection } = this.uiStore;
    const { classes } = this.props;

    return (
      <React.Fragment>
        {showPatientSelection && (
          <PatientSearchDialog
            parentCallBack={this.patientSelectionResult}
            showSearchDialog={showSearchDialog}
            toggleSearchDialog={this.close}
          />
        )}
        <UIDialog
          open={showPatientSelection && !showSearchDialog}
          fullScreen={true}
          title="Schedule"
          rightNav={() => (
            <CloseIcon onClick={togglePatientSelection} color="inherit" />
          )}
          content={() => (
            <List>
              {this.isPatientSelected() && (
                <PatientSelectionCard
                  parentCallBack={this.patientSelectionResult}
                />
              )}
              <ListItem
                button
                onClick={this.toggleSearchDialog}
                className={classes.buttonContainer}
              >
                <Typography align="center" className={classes.searchButton}>
                  Search for Another Patient
                </Typography>
              </ListItem>
            </List>
          )}
        />
      </React.Fragment>
    );
  }
}

AppointmentPatientSelectionDialog.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(observer(AppointmentPatientSelectionDialog));
